import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  USER_GET_SUBSCRIPTION_INVITATIONS_BEGIN,
  USER_GET_SUBSCRIPTION_INVITATIONS_SUCCESS,
  USER_GET_SUBSCRIPTION_INVITATIONS_FAILURE,
  USER_GET_SUBSCRIPTION_INVITATIONS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { createAxiosConfigWithAuth } from '../../../common/apiHelpers';
import config from '../../../common/config';

export function getSubscriptionInvitations(args = {}) {
  return (dispatch, getState) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: USER_GET_SUBSCRIPTION_INVITATIONS_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${config.apiRootUrl}/users/${args.id}/invitations/`,
        createAxiosConfigWithAuth(getState()),
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: USER_GET_SUBSCRIPTION_INVITATIONS_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: USER_GET_SUBSCRIPTION_INVITATIONS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetSubscriptionInvitationsError() {
  return {
    type: USER_GET_SUBSCRIPTION_INVITATIONS_DISMISS_ERROR,
  };
}

export function useGetSubscriptionInvitations() {
  const dispatch = useDispatch();

  const { getSubscriptionInvitationsPending, getSubscriptionInvitationsError } =
    useSelector(
      (state) => ({
        getSubscriptionInvitationsPending:
          state.user.getSubscriptionInvitationsPending,
        getSubscriptionInvitationsError:
          state.user.getSubscriptionInvitationsError,
      }),
      shallowEqual,
    );

  const boundAction = useCallback(
    (...args) => {
      return dispatch(getSubscriptionInvitations(...args));
    },
    [dispatch],
  );

  const boundDismissError = useCallback(() => {
    return dispatch(dismissGetSubscriptionInvitationsError());
  }, [dispatch]);

  return {
    getSubscriptionInvitations: boundAction,
    getSubscriptionInvitationsPending,
    getSubscriptionInvitationsError,
    dismissGetSubscriptionInvitationsError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case USER_GET_SUBSCRIPTION_INVITATIONS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getSubscriptionInvitationsPending: true,
        getSubscriptionInvitationsError: null,
      };

    case USER_GET_SUBSCRIPTION_INVITATIONS_SUCCESS:
      // The request is success
      return {
        ...state,
        getSubscriptionInvitationsPending: false,
        getSubscriptionInvitationsError: null,
      };

    case USER_GET_SUBSCRIPTION_INVITATIONS_FAILURE:
      // The request is failed
      return {
        ...state,
        getSubscriptionInvitationsPending: false,
        getSubscriptionInvitationsError: action.data.error,
      };

    case USER_GET_SUBSCRIPTION_INVITATIONS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getSubscriptionInvitationsError: null,
      };

    default:
      return state;
  }
}
